export default __webpack_public_path__ + "static/media/20.04f11c01.svg";